import collapseHandler from '../utils/setCollapse';
import placeHolderOps from './placeHolderOps';
import getCardInfoByType from './getCardInfoByType';
import dragEndOrg from './dragEndOrg';
import dragEndRole from './dragEndRole';
import dragEndArrayItem from './dragEndArrayItem';

export default (params) => {
  const {
    e,
    editor,
    node,
    collapse,
    dragType,
    setCollapse,
    dragOverCords,
    mostUsedToolSetRef,
    statusBarRef,
  } = params;

  const droppable = document.querySelector('.editor');

  const { afterOrg, parentNode, afterRole } = getCardInfoByType({
    e,
    dragType,
    droppable,
    clientY: dragOverCords && dragOverCords.y,
  });

  const el = e.target;
  el.classList.remove('dragging');

  if (dragType === 'ROLE_ARRAY_ITEM' || dragType === 'ARRAY_ITEM') {
    el.style.display = 'grid';
    const { setDrag } = params;
    setTimeout(() => setDrag({ dragType: null }), 0);
  } else {
    collapseHandler({
      el,
      editor,
      collapse,
      setCollapse,
      collapseVal: false,
      dragType: null,
    });
  }

  /**
   * Remove placeholder
   */
  placeHolderOps(parentNode);

  const { key: currentNodeKey } = node;

  if (dragType === 'ORGANIZATION') {
    dragEndOrg({
      el,
      node,
      afterOrg,
      editor,
      currentNodeKey,
      dragType,
    });
  } else if (dragType === 'ROLE' || dragType === 'ROLE_ARRAY_ITEM') {
    dragEndRole({
      parentNode,
      afterRole,
      editor,
      currentNodeKey,
      dragType,
      node,
      el,
      mostUsedToolSetRef,
      statusBarRef,
    });
  } else if (dragType === 'ARRAY_ITEM') {
    dragEndArrayItem({
      afterRole,
      editor,
      currentNodeKey,
      dragType,
    });
  }

  return null; // TODO: Is it required anymore?
};
